import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {AppService} from 'app/services/app.service';
import {environment} from '../../../environments/environment';
import {UserModelService} from 'app/models/user-model.service';
import {OtherModelService} from 'app/models/other-model.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  // @TODO change, so it can take version from package
  appVersion = '0.0.11';

  constructor(
    private appService: AppService,
    private userModelService: UserModelService,
    private otherModelService: OtherModelService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log('request', request);

    // особый случай cross origin request - в него нужно в хедер так же добавить appversion
    if (request.url.indexOf(this.otherModelService.urlJiraBugReport) >= 0) {
      request = request.clone({
        setHeaders: {
          appVersion: this.appVersion
        } as any
      });
    }

    if (request.url.indexOf(environment.baseUrl) >= 0) {

      // if (this.userModelService.token) {
      //   request = request.clone({
      //     setParams: {
      //       // eslint-disable-next-line @typescript-eslint/naming-convention
      //       auth_key: this.userModelService.token
      //     }
      //   });
      // }

      if (this.appService.getLocalStorage('deviceToken')) {
        request = request.clone({
          setHeaders: {
            appDeviceToken: this.appService.getLocalStorage('deviceToken')
          } as any
        });
      }

      if (this.userModelService.token) {
        request = request.clone({
          setHeaders: {
            appToken: this.userModelService.token
          } as any
        });
      }

      // if (this.userModelService.token) {
      request = request.clone({
        setHeaders: {
          appVersion: this.appVersion
        } as any
      });

      // request = request.clone({
      //   setHeaders: {
      //     appDevice: '0.0.7'
      //   } as any
      // });
      // }

      //
      // if (this.userModelService.selectedCustomer?.id) {
      //   request = request.clone({
      //     setHeaders: {
      //       customerToken: this.customersModelService.selectedCustomer.id.toString()
      //     } as any
      //   });
      // }
    }

    return next.handle(request);
  }

}
